import { Component } from "@angular/core";

@Component({
  selector: "app-introduction",
  templateUrl: "./introduction.component.html",
})
export class IntroductionComponent {}
